'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createCharge;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createCharge() {
    var fixture = init();

    function init() {
        return {
            id: Math.random(),
            type: 'discount',
            mandatory: false,
            operator: {},
            condition: {
                type: 'and',
                conditions: [{ type: 'true' }, { type: 'true' }, { type: 'true' }, { type: 'true' }, { type: 'true' }]
            },
            displayCondition: {
                type: 'and',
                conditions: [{ type: 'true' }, { type: 'true' }, { type: 'true' }, { type: 'true' }, { type: 'true' }]
            }
        };
    }

    return {
        id: function id(_id) {
            fixture.id = _id;
            return this;
        },
        title: function title(val) {
            fixture.title = { 'en_US': val };
            return this;
        },
        description: function description(val) {
            fixture.title = { 'en_US': val };
            return this;
        },
        percentageDiscount: function percentageDiscount(_ref) {
            var percentage = _ref.percentage,
                itemIds = _ref.itemIds,
                chargeIds = _ref.chargeIds;

            fixture.type = 'discount';
            fixture.operator = {
                type: 'multiply',
                numerators: [{ type: 'sum_prices',
                    items: itemIds ? { type: 'include', ids: itemIds } : { type: 'exclude', ids: [] },
                    charges: chargeIds ? { type: 'include', ids: chargeIds } : null
                }, { type: 'value', value: percentage }],
                denominators: [{ type: 'value', value: -100000 }]
            };

            return this;
        },
        fixedDiscount: function fixedDiscount(_ref2) {
            var price = _ref2.price,
                itemIds = _ref2.itemIds;

            fixture.type = 'discount';
            fixture.operator = {
                type: 'multiply',
                numerators: [{ type: 'count_items', items: itemIds ? { type: 'include', ids: itemIds } : { type: 'exclude', ids: [] } }, { type: 'value', 'value': price }],
                denominators: [{ type: 'value', 'value': -1 }]
            };

            return this;
        },
        tax: function tax(_ref3) {
            var percentage = _ref3.percentage,
                itemIds = _ref3.itemIds,
                chargeIds = _ref3.chargeIds;

            this.percentageDiscount({ percentage: percentage, itemIds: itemIds, chargeIds: chargeIds });
            fixture.type = 'tax';
            fixture.operator.denominators[0].value *= -1;

            return this;
        },
        tip: function tip() {
            fixture.type = 'tip';
            return this;
        },
        deliveryTypes: function deliveryTypes(types) {
            if (types) {
                fixture.condition.conditions[1] = {
                    type: 'or', conditions: _lodash2.default.map(types, function (t) {
                        return { type: 'order_delivery_type', deliveryType: t };
                    })
                };
            } else {
                fixture.condition.conditions[1] = { type: 'true' };
            }
            return this;
        },
        platforms: function platforms(platform) {
            if (platform) {
                fixture.condition.conditions[2] = {
                    type: 'or', conditions: _lodash2.default.map(platform, function (t) {
                        return { type: 'order_platform', platform: t };
                    })
                };
            } else {
                fixture.condition.conditions[2] = { type: 'true' };
            }
            return this;
        },
        min: function min(_min) {
            if (_min) {
                fixture.condition.conditions[3] = { type: 'order_items_price', min: _min };
            } else {
                fixture.condition.conditions[3] = { type: 'true' };
            }
            return this;
        },
        deliveryTime: function deliveryTime(availability) {
            if (availability) {
                fixture.condition.conditions[4] = { type: 'order_delivery_time', availability: availability };
            } else {
                fixture.condition.conditions[4] = { type: 'true' };
            }
            return this;
        },
        coupon: function coupon(couponHashCode) {
            var condition = {
                type: 'order_coupon',
                couponHashCode: couponHashCode
            };

            fixture.condition.conditions.unshift(condition);
            fixture.displayCondition.conditions.unshift(condition);

            return this;
        },
        displayConditionDeliveryTypes: function displayConditionDeliveryTypes(types) {
            if (types) {
                fixture.displayCondition.conditions[1] = {
                    type: 'or', conditions: _lodash2.default.map(types, function (t) {
                        return { type: 'order_delivery_type', deliveryType: t };
                    })
                };
            } else {
                fixture.displayCondition.conditions[1] = { type: 'true' };
            }
            return this;
        },
        displayConditionPlatforms: function displayConditionPlatforms(platform) {
            if (platform) {
                fixture.displayCondition.conditions[2] = {
                    type: 'or', conditions: _lodash2.default.map(platform, function (t) {
                        return { type: 'order_platform', platform: t };
                    })
                };
            } else {
                fixture.displayCondition.conditions[2] = { type: 'true' };
            }
            return this;
        },
        displayConditionMin: function displayConditionMin(min) {
            if (min) {
                fixture.displayCondition.conditions[3] = { type: 'order_items_price', min: 123 };
            } else {
                fixture.displayCondition.conditions[3] = { type: 'true' };
            }
            return this;
        },
        displayConditionDeliveryTime: function displayConditionDeliveryTime(availability) {
            if (availability) {
                fixture.displayCondition.conditions[4] = { type: 'order_delivery_time', availability: availability };
            } else {
                fixture.displayCondition.conditions[4] = { type: 'true' };
            }
            return this;
        },
        close: function close() {
            fixture.state = 'closed';
            return this;
        },
        mandatory: function mandatory() {
            fixture.mandatory = true;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/ChargeV2.js
// module id = 714
// module chunks = 0